import { Injectable } from '@angular/core';
import { Observable, from, map } from 'rxjs';
import { getCountryLookups } from '../../../api/gse/fn/lookups/get-country-lookups';
import { CountryLookupResponse } from '../../../api/gse/models/country-lookup-response';
import { CountryDto } from '../../../api/gse/models/country-dto';
import { Api } from '../../../api/gse/api';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  
  constructor(private api: Api) { }

  /**
   * Get all country lookups
   * @returns Observable<CountryLookupResponse>
   */
  getCountryLookups(): Observable<CountryLookupResponse> {
    return from(this.api.invoke(getCountryLookups, {}));
  }

  /**
   * Get all countries as array
   * @returns Observable<CountryDto[]>
   */
  getAllCountries(): Observable<CountryDto[]> {
    return this.getCountryLookups().pipe(
      map((res) => res.data || [])
    );
  }
}